import { useCallback, useRef } from "react";
import { useStore } from "react-redux";

import {
  getEventRecordingExtras,
  recordEvent,
} from "src/apiService/modules/events";
import type { Event } from "src/interfaces/event";
import { userClaimsSelector } from "src/store/system/selector";

export function useRecordEvent() {
  const store = useStore();
  const storeRef = useRef(store);
  storeRef.current = store;

  return useCallback((event: Event) => {
    const extras = getEventRecordingExtras(
      userClaimsSelector(storeRef.current.getState())
    );
    if (extras === null) return;
    void recordEvent(event, extras);
  }, []);
}
